import styled from '@emotion/styled';

export const StyledTitle = styled.div`
  font-family: 'Urbanist';
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  color: ${({ theme }) => theme.palette?.text?.primary};
  margin-top: 2rem;
`;

export const StyledCustomAccount = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
